import axios from 'axios';

import type { GetApiV1WeeklyRoundupsLatestResponses } from '~/api/generated';

export type WeeklyRoundup = GetApiV1WeeklyRoundupsLatestResponses[200];

export async function fetchLatestWeeklyRoundup(): Promise<WeeklyRoundup | null> {
  const { data, status } = await axios.get<WeeklyRoundup>('/api/v1/weekly_roundups/latest');

  return status === 204 ? null : data;
}
